import {
  typeEnum,
  colorsEnum,
  AVERAGE_VEL_SETTING,
  SICK_TIME,
  RADIUS,
  getWallCoords,
} from "./CovidHerdImmunityConstants";

class Particle {
  constructor(
    particleCanvas,
    type = typeEnum.HEALTHY,
    quarantine = 0.9,
    confined = false
  ) {
    this.particleCanvas = particleCanvas;
    this.x = Math.random() * this.particleCanvas.width;
    this.y = Math.random() * this.particleCanvas.height;

    const angle = Math.random() * 2 * Math.PI;
    this.vx = Math.cos(angle) * AVERAGE_VEL_SETTING;
    this.vy = Math.sin(angle) * AVERAGE_VEL_SETTING;

    this.type = type;
    this.collisions = 0;

    this.confined = confined;
    this.quarantine = quarantine;
  }

  makeSick() {
    this.type = typeEnum.SICK;
    this.sick_time =
      new Date().getTime() + SICK_TIME * Math.log(1 / (1 - Math.random()));
  }

  draw(correctionFactor) {
    if (this.type === typeEnum.DEAD || this.confined) {
      this.vx = 0;
      this.vy = 0;
    } else {
      this.vx *= correctionFactor;
      this.vy *= correctionFactor;

      this.x += this.vx;
      this.y += this.vy;

      // bound collision
      if (this.x > this.particleCanvas.width - RADIUS && this.vx > 0) {
        this.x -= 2 * (this.x - (this.particleCanvas.width - RADIUS));
        this.vx = -this.vx;
      }

      if (this.x < RADIUS && this.vx < 0) {
        this.x -= 2 * (this.x - RADIUS);
        this.vx = -this.vx;
      }

      if (this.y > this.particleCanvas.height - RADIUS && this.vy > 0) {
        this.y -= 2 * (this.y - (this.particleCanvas.height - RADIUS));
        this.vy = -this.vy;
      }

      if (this.y < RADIUS && this.vy < 0) {
        this.y -= 2 * (this.y - RADIUS);
        this.vy = -this.vy;
      }

      // quarantine wall
      const QUARANTINE_HOLE_LENGTH =
        this.particleCanvas.height * (1 - this.quarantine);
      const WALL_COORDS = getWallCoords(this.particleCanvas);
      if (
        this.x > WALL_COORDS[0] &&
        this.x < WALL_COORDS[1] &&
        (this.y <
          this.particleCanvas.height / 2.0 - QUARANTINE_HOLE_LENGTH / 2.0 ||
          this.y >
            this.particleCanvas.height / 2.0 + QUARANTINE_HOLE_LENGTH / 2.0)
      ) {
        if (this.vx > 0) {
          this.x = WALL_COORDS[0];
        } else {
          this.x = WALL_COORDS[1];
        }

        this.vx = -this.vx;
      }
    }

    //draw particle
    const ctx1 = this.particleCanvas.getContext("2d");
    ctx1.fillStyle = colorsEnum[this.type];
    ctx1.beginPath();
    ctx1.arc(this.x, this.y, RADIUS, 0, 2 * Math.PI);
    ctx1.fill();
  }
}

export default Particle;
